// import { siteConfig } from '@/configs/siteConfig';

// import { siteState } from '@/modules/siteState/siteStateGetter';

// const props = {};

export const formManager = {
  init() {
    this.selectBox();
  },

  selectBox() {
    const selectEl = document.getElementById('js-formYourType') as HTMLSelectElement | null;
    if (selectEl) {
      const params = new URLSearchParams(window.location.search);
      const typeParam = params.get('type');

      if (typeParam === 'recruit') {
        selectEl.value = '採用について';
      } else if (typeParam === 'other') {
        selectEl.value = 'その他のお問い合わせ';
      } else if (typeParam === 'external') {
        selectEl.value = 'ＪＲ西日本グループ倫理・人権ホットライン';
      } else if (typeParam === 'lawyer') {
        selectEl.value = '弁護士事務所（弁護士法人 KM 総合）';
      }
    }
  },
};
